module.exports = __webpack_public_path__ + "media/images/contact/minneapolis-dd97f1d4d52f7466d0ca38c59d34ee1e.jpg";